module.exports = __webpack_public_path__ + "static/media/Inspiron2.d16ec065.png";